// extracted by mini-css-extract-plugin
export default {"form-container":"Signin_form-container__xvSqt","title":"Signin_title__NYVfo","form-group":"Signin_form-group__w9veh","button":"Signin_button__XHiLZ"};